import React, { Component, Fragment } from 'react';
import { parse } from 'query-string';
import Field from '../components/ui/field';
import PaginationNew from '../components/ui/paginationNew';
import Loader from '../components/ui/Loader';
import withAppLayout from '../components/appLayout';
import SearchResultTable from '../components/search/searchResultTable';
import TableBody from '../components/search/tableBody';
import TableHead from '../components/search/tableHead';
import { Api } from '../api';
import cx from 'classnames';
import FundAvatar from '../components/common/fundAvatar';
import { TABLE_HEADER_SEARCH } from '../constants';
import Anchor from '../components/ui/Anchor';
import InvestFlowHandler from '../components/common/investFlowHandler';
// @ts-ignore
import { Router } from '../configs/routes';
import searchStyles from '../styles/search.scss';
import { trackAction } from '../utils/trackActions';
import FilterGroup from '../components/search/filterGroup';
import Modal from '../components/modal';
import {
  filterDataMap,
  filterCategoryMap,
  stagingAlgoliaIndex,
  algoliaIndex,
} from '../constants/searchConstants';
import ActionMenu from '../components/common/actionMenu';
import { searchPageActions } from '../constants/actionMenu';
import withCompareWidget from '../components/common/compareWidgetHOC';
import Tabs from '../components/ui/tabs';
import SuggestedFundsModal from '../components/common/suggestedFundModal';
import getConfig from 'next/config';
import { sortAscending, sortDescending } from '../utils/arrayUtil';
const { publicRuntimeConfig } = getConfig();

interface State {
  query: string;
  results: any[];
  facetFilters: string[];
  activeItem: number | null;
  selectedFund?: any;
  startInvestmentFlow?: boolean;
  currentSelectedPage: number;
  totalResults: number;
  resultPerPage: number;
  totalPages: number;
  loading: boolean;
  filterCategoryValueMap?: any;
  sortBy: string;
  showFilterModal: boolean;
  selectedTab: string;
  filtersToApply?: any;
  isinCode: string;
  showInvestmentDeniedModal: boolean;
  sortedAscending: boolean;
}

interface Props {
  url: any;
  addFundToCompare: (fundItem: any) => void;
}

const api = new Api();

class Search extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const filters = JSON.parse(props.url.query.filters || '{}');
    const {
      query,
      facetFilters,
      filterCategoryValueMap,
      sortBy,
      currentSelectedPage,
    } = filters;

    const getSortBy = (sortByNew: string) => {
      if (sortByNew) {
        return sortByNew;
      } else if (
        publicRuntimeConfig.env === 'development' ||
        publicRuntimeConfig.env === 'staging'
      ) {
        return stagingAlgoliaIndex;
      } else {
        return algoliaIndex;
      }
    };

    this.state = {
      query: query || '',
      results: [],
      facetFilters: facetFilters || [],
      activeItem: null,
      currentSelectedPage: currentSelectedPage || 0,
      totalResults: 0,
      resultPerPage: 0,
      totalPages: 0,
      loading: true,
      filterCategoryValueMap: filterCategoryValueMap || {
        fundType: [],
        purchaseMode: ['DIRECT'],
        enabled: [true],
        issuingAuthority: [],
        'fundMetaData.exitLoad.percentage': [],
        'categoryFilter.categoryFilterValue': [],
        'fundMetaData.risk': [],
      },
      sortBy: getSortBy(sortBy),
      showFilterModal: false,
      selectedTab: 'fundType',
      filtersToApply: null,
      isinCode: '',
      showInvestmentDeniedModal: false,
      sortedAscending: false,
    };
  }

  private updateQueries = (clearAll?: boolean) => {
    const {
      query,
      facetFilters,
      filterCategoryValueMap,
      sortBy,
      currentSelectedPage,
    } = this.state;
    const filters = JSON.stringify({
      query,
      facetFilters,
      filterCategoryValueMap,
      sortBy,
      currentSelectedPage,
    });
    const queries = parse(location.search);
    if (clearAll) {
      delete queries.filters;
    } else {
      queries.filters = filters;
    }
    Router.pushRoute('search', queries, { shallow: true });
  };

  public handleSearchChange = (e: any) => {
    const { value } = e.target;
    this.setState(
      {
        query: value,
        currentSelectedPage: 0,
      },
      () => {
        this.updatePage(this.state.query);
      }
    );
  };

  public componentDidMount() {
    const { fundId } = this.props.url.query;
    this.searchFund(this.state.query, this.state.currentSelectedPage).then(
      () => {
        if (fundId) {
          this.startInvestment(fundId, 'productId');
        }
      }
    );
  }

  public searchFund(value: string, pageNo?: number) {
    const { query, filterCategoryValueMap, sortBy } = this.state;
    const facetFilters = Object.keys(filterCategoryValueMap).map((key) => {
      return filterCategoryValueMap[key].map(
        (category) => `${key}:${category}`
      );
    });
    return api
      .searchFund(value, pageNo, facetFilters, sortBy)
      .then((searchResults) => {
        if (query && query !== searchResults.query) {
          return;
        }
        const resultsHits = searchResults.hits || [];
        const results = resultsHits.map((item) => {
          return {
            ...item,
            return3yr: item.fundMetaData.returns.return3yr,
            return5yr: item.fundMetaData.returns.return5yr,
          };
        });
        const {
          hitsPerPage: resultPerPage,
          nbHits: totalResults,
          nbPages: totalPages,
        } = searchResults;
        this.setState({
          results,
          resultPerPage,
          totalResults,
          totalPages,
          loading: false,
        });
        return results;
      });
  }

  public navigateToFund(id: number, slug: string) {
    trackAction('click', `${id}`, 'search');
    Router.pushRoute(slug, slug, { shallow: true });
  }

  public getTableItems() {
    const { activeItem, results } = this.state;
    return results.map((fund) => {
      const {
        fundName,
        imageUrl,
        subCategory,
        fundMetaData,
        productId,
        enabled,
        categoryFilter,
        fundType,
        minSipAmount,
        planType = 'GROWTH',
      } = fund;

      let return3yr;
      let return5yr;
      let slug;
      let parentSlug;
      let isinCode;
      let minInvestmentAmount;
      if (fundMetaData) {
        slug = fundMetaData.slug;
        parentSlug = fundMetaData.parentSlug;
        return3yr = fundMetaData.returns && fundMetaData.returns.return3yr;
        return5yr = fundMetaData.returns && fundMetaData.returns.return5yr;
        isinCode = fundMetaData.isinCode;
      }

      return3yr = return3yr ? `${return3yr}%` : '--';
      return5yr = return5yr ? `${return5yr}%` : '--';
      minInvestmentAmount = minSipAmount ? minSipAmount : '--';

      const isActive = activeItem && productId === activeItem;
      const path = `/mutual-funds/${parentSlug}/${slug}/${isinCode}?planType=${planType}`;
      return {
        isActive,
        rowItems: [
          {
            className: 'large-3 small-7',
            component: (
              <FundAvatar
                fundItem={{
                  fundName,
                  imageUrl,
                  planType,
                  subTitle: `${fundType} - ${
                    categoryFilter !== null
                      ? categoryFilter[0].categoryFilterValue
                      : subCategory
                  }`,
                  fundMetaData: {
                    slug,
                    parentSlug,
                    isinCode,
                  },
                }}
                width={20}
                imageValign="super"
                hideSubTitle={false}
                source="search"
              />
            ),
          },
          {
            className: 'large-2 desktop-only',
            component: `${return3yr}`,
          },
          {
            className: 'large-2 small-3',
            component: `${return5yr}`,
          },
          {
            className: 'large-2 desktop-only',
            component: `${minInvestmentAmount}`,
          },
          {
            className: cx('large-2 small-3 desktop-only pl0'),
            component: (
              <Anchor
                name="Invest now"
                className={cx(
                  {
                    's-btn s-btn--blue': isActive,
                    [searchStyles['white-btn']]: isActive,
                  },
                  searchStyles['search-item-btn'],
                  'btn-search'
                )}
                onClick={(e: any) => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.startInvestment(isinCode, 'isinCode');
                }}
              />
            ),
          },
          {
            className: cx('large-1 small-2 pl0'),
            component: (
              <div className="columns">
                <ActionMenu
                  actions={searchPageActions.map((action) => {
                    if (action.key === 'invest') {
                      action.hide = enabled;
                    }
                    return action;
                  })}
                  itemId={isinCode}
                  handleActionClick={(action) =>
                    this.handleActionItemClick(action, fund)
                  }
                />
              </div>
            ),
          },
        ],
        onRowClick: () => this.navigateToFund(productId, path),
      };
    });
  }

  private handleActionItemClick = (action: string, fundItem: any) => {
    if (action === 'invest') {
      this.startInvestment(fundItem.isinCode, 'isinCode');
    } else if (action === 'compare') {
      this.props.addFundToCompare(fundItem);
    }
  };

  private getInvestmentDeniedModal = (allowed: boolean) => {
    return allowed ? (
      <SuggestedFundsModal
        dismissModal={this.dismissModal}
        isinCode={this.state.isinCode}
      />
    ) : null;
  };

  private startInvestment = (id: number, key: string) => {
    trackAction('click', `${id}`, 'search-item-invest-now-btn');
    const { results } = this.state;
    const selectedFund =
      results.find((result) => result[key] && id && result[key] === id) || {};

    const { isinCode, enabled, productId } = selectedFund;

    if (!enabled || !productId) {
      return this.setState({
        isinCode,
        showInvestmentDeniedModal: true,
      });
    }

    selectedFund.id = selectedFund.productId;
    this.setState({
      selectedFund,
      startInvestmentFlow: true,
    });
    Router.pushRoute(
      'search',
      { ...this.props.url.query, fundId: productId },
      { shallow: true }
    );
  };

  private dismissModal = () => {
    this.setState({
      startInvestmentFlow: false,
      showInvestmentDeniedModal: false,
    });
  };

  private handlePaginationItemClick = (e: any) => {
    const { query } = this.state;
    const { target } = e;
    const nextButton = target.getAttribute('data-click-item');
    if (target.getAttribute('data-list-item')) {
      const pageNumber = Number(target.textContent);
      this.searchFund(query, pageNumber - 1);
      this.setState({
        currentSelectedPage: pageNumber - 1,
      });
    } else if (nextButton !== null && nextButton !== undefined) {
      this.searchFund(query, Number(nextButton));
      this.setState({
        currentSelectedPage: Number(nextButton),
      });
    }
  };

  private getPaginationItems() {
    const { totalPages } = this.state;
    const paginationItems = [];
    for (let i = 1; i <= totalPages; i++) {
      paginationItems.push(i);
    }
    return paginationItems;
  }

  private onSortProcessingOrder = (sortKey: string) => {
    const { results, sortedAscending } = this.state;
    if (sortedAscending) {
      const sortedArr = sortDescending(results, sortKey);
      this.setState({
        results: sortedArr,
        sortedAscending: false,
      });
    } else {
      this.setState(
        {
          sortedAscending: true,
        },
        () => {
          const sortedArr = sortAscending(results, sortKey);
          this.setState({
            results: sortedArr,
          });
        }
      );
    }
  };

  public renderTable() {
    const {
      results,
      currentSelectedPage,
      loading,
      totalResults,
      showInvestmentDeniedModal,
    } = this.state;

    if (results.length) {
      return (
        <div className="large-9 columns" style={{ padding: 0 }}>
          <SearchResultTable
            tableClassname={cx(searchStyles['custom-col-padding'], 'large-12')}
          >
            <TableHead
              items={TABLE_HEADER_SEARCH}
              onSort={this.onSortProcessingOrder}
            />
            <TableBody items={this.getTableItems()} />

            {this.getInvestmentDeniedModal(showInvestmentDeniedModal)}
          </SearchResultTable>
          <div className="lil-mb-10">
            {totalResults > 20 ? (
              <PaginationNew
                items={this.getPaginationItems()}
                currentSelectedPage={currentSelectedPage}
                onItemClick={this.handlePaginationItemClick}
                maxItemsToShow={8}
              />
            ) : null}
          </div>
        </div>
      );
    } else if (!loading) {
      return (
        <div className="row">
          <div className="large-8 columns">
            <p
              className={cx(
                searchStyles['search-title'],
                'center',
                searchStyles['mt50']
              )}
            >
              Uh oh! No results found.
            </p>
            <img src="" />
          </div>
        </div>
      );
    }
  }

  private onChangeFilter = (e: any) => {
    const key = e.currentTarget.getAttribute('data-attr');
    const category = e.currentTarget.getAttribute('data-category');
    const { query, filterCategoryValueMap } = this.state;
    let filterCategory = filterCategoryValueMap[category];
    const keyExist = filterCategory.indexOf(key) !== -1;

    // Allows to select only one Category at a time
    if (category === 'fundType' && !keyExist) {
      filterCategory = [];
      filterCategoryValueMap['categoryFilter.categoryFilterValue'] = [];
    }

    filterCategory = keyExist
      ? filterCategory.filter((filter) => filter !== key)
      : filterCategory.concat(key);

    const newFilterCategoryMap = {
      ...filterCategoryValueMap,
      [category]: filterCategory,
    };

    let filterSubCategory =
      filterCategoryValueMap['categoryFilter.categoryFilterValue'];

    // This part removes subcategories from filter if we deselect the category
    if (category === 'fundType' && keyExist) {
      const categoryData = filterDataMap[category].filter(
        (f) => f.key === key
      )[0];
      const subCategoryExist = categoryData.hasOwnProperty(
        'categoryFilter.categoryFilterValue'
      );
      if (subCategoryExist) {
        const allSubCategory = categoryData[
          'categoryFilter.categoryFilterValue'
        ].map((f) => f.key);
        filterSubCategory = filterSubCategory.filter(
          (val) => !allSubCategory.includes(val)
        );
        newFilterCategoryMap['categoryFilter.categoryFilterValue'] =
          filterSubCategory;
      }
    }
    this.setState(
      {
        filterCategoryValueMap: newFilterCategoryMap,
        currentSelectedPage: 0,
      },
      () => {
        this.updatePage(query);
      }
    );
    e.stopPropagation();
  };

  private handleFilterClick = (e: any) => {
    const key = e.currentTarget.getAttribute('data-attr');
    const category = e.currentTarget.getAttribute('data-category');
    const { filterCategoryValueMap, filtersToApply } = this.state;
    const currentFilters = {
      ...filterCategoryValueMap,
      ...(filtersToApply || {}),
    };

    let filterCategory = currentFilters[category];

    const keyExist = filterCategory.indexOf(key) !== -1;
    // TODO: better approach to handle mobile filter clicks
    // Allows to select only one Category at a time
    if (category === 'fundType' && !keyExist) {
      filterCategory = [];
      currentFilters['categoryFilter.categoryFilterValue'] = [];
    }

    filterCategory = keyExist
      ? filterCategory.filter((filter) => filter !== key)
      : filterCategory.concat(key);

    const newFilterCategoryMap = {
      ...currentFilters,
      [category]: filterCategory,
    };

    // This part removes subcategories from filter if we deselect the category
    let filterSubCategory =
      filterCategoryValueMap['categoryFilter.categoryFilterValue'];

    if (category === 'fundType' && keyExist) {
      const categoryData = filterDataMap[category].filter(
        (f) => f.key === key
      )[0];
      const subCategoryExist = categoryData.hasOwnProperty(
        'categoryFilter.categoryFilterValue'
      );
      if (subCategoryExist) {
        const allSubCategory = categoryData[
          'categoryFilter.categoryFilterValue'
        ].map((f) => f.key);
        filterSubCategory = filterSubCategory.filter(
          (val) => !allSubCategory.includes(val)
        );
        newFilterCategoryMap['categoryFilter.categoryFilterValue'] =
          filterSubCategory;
      }
    }

    this.setState({
      filtersToApply: newFilterCategoryMap,
      currentSelectedPage: 0,
    });
    e.stopPropagation();
  };

  public clearAllFilters = () => {
    const { query } = this.state;
    this.setState(
      {
        filterCategoryValueMap: {
          fundType: [],
          purchaseMode: ['DIRECT'],
          enabled: [true],
          issuingAuthority: [],
          'fundMetaData.exitLoad.percentage': [],
          'categoryFilter.categoryFilterValue': [],
        },
        filtersToApply: null,
      },
      () => {
        this.updatePage(query);
      }
    );
  };

  private updatePage = (query: string) => {
    this.updateQueries();
    this.searchFund(query, 0);
  };

  private getFilters = (
    selectedTab: string = '',
    isMobile: boolean = false
  ) => {
    const { filtersToApply, filterCategoryValueMap } = this.state;

    const visibleCategoriess = selectedTab
      ? filterCategoryMap.filter(
          (f) =>
            f.key === selectedTab &&
            f.key !== 'categoryFilter.categoryFilterValue' &&
            f.key !== 'fundMetaData.risk'
        )
      : filterCategoryMap.filter(
          (f) =>
            f.key !== 'categoryFilter.categoryFilterValue' &&
            f.key !== 'fundMetaData.risk'
        );
    return (
      <div className={searchStyles['filter-group']}>
        {visibleCategoriess.map((category) => (
          <FilterGroup
            filterCategoryValueMap={filtersToApply || filterCategoryValueMap}
            filters={filterDataMap[category.category]}
            onCheckboxClick={
              isMobile ? this.handleFilterClick : this.onChangeFilter
            }
            showSubFilter={true}
            category={category.category}
            key={category.label}
            filterName={category.label}
          />
        ))}
      </div>
    );
  };

  private showFilterModal = () => {
    this.setState({
      showFilterModal: true,
    });
  };

  private onModalClose = () => {
    this.setState({
      showFilterModal: false,
    });
  };

  private handleChangeTab = (e: any) => {
    const { currentTarget } = e;
    const selectedTab = currentTarget.getAttribute('data-tab');
    this.setState({
      selectedTab,
    });
  };

  private clearSelection = () => {
    this.setState({
      filtersToApply: null,
      showFilterModal: false,
    });
  };

  private applyFilters = () => {
    const { filtersToApply, query, filterCategoryValueMap } = this.state;
    this.setState(
      {
        filterCategoryValueMap: filtersToApply || filterCategoryValueMap,
        showFilterModal: false,
      },
      () => {
        this.updatePage(query);
      }
    );
  };

  private getFilterModalHeader = () => {
    return (
      <div className={cx('row', searchStyles['modal-header'])}>
        <div
          className={cx(
            'columns small-9 font--bold text--xlg',
            searchStyles['header-cols']
          )}
        >
          Filters
        </div>
        <div
          className={cx(
            'columns small-3 text-right font--grey text--uppercase',
            searchStyles['header-cols']
          )}
          onClick={this.clearAllFilters}
        >
          Clear All
        </div>
      </div>
    );
  };

  private getFilterContentMobile = () => {
    const { showFilterModal, selectedTab } = this.state;

    return (
      <div className="mobile-only--display">
        <div className="filter-modal">
          {showFilterModal ? (
            <Modal
              fullScreen
              hideHeader={showFilterModal}
              title="Sort By"
              onDismiss={this.onModalClose}
              padding="1px"
              headerPad={20}
              marginBottom="0px"
            >
              {showFilterModal ? this.getFilterModalHeader() : null}
              <div className="row ml0 mr0">
                {showFilterModal ? (
                  <div
                    style={{ height: 'calc(100vh - 60px)' }}
                    className="columns small-4 pl0 pr0"
                  >
                    <Tabs
                      className="mobile-filter-tabs"
                      align="vertical"
                      items={filterCategoryMap.filter(
                        (f) =>
                          ![
                            'categoryFilter.categoryFilterValue',
                            'fundMetaData.risk',
                          ].includes(f.key)
                      )}
                      selected={selectedTab}
                      switchTabs={this.handleChangeTab}
                    />
                  </div>
                ) : null}
                <div
                  className={cx('columns pt10', {
                    'small-8': showFilterModal,
                  })}
                >
                  {showFilterModal ? this.getFilters(selectedTab, true) : null}
                </div>
              </div>
              {showFilterModal ? (
                <div className={cx('row', searchStyles['bottom-nav'])}>
                  <div
                    className="columns small-6 text--uppercase font--bold font--grey"
                    onClick={this.clearSelection}
                  >
                    Close
                  </div>

                  <div
                    onClick={this.applyFilters}
                    className="columns small-6 text--uppercase font--blue font--bold"
                  >
                    Apply
                  </div>
                </div>
              ) : null}
            </Modal>
          ) : null}
        </div>
        <div className={cx('row', searchStyles['bottom-nav'])}>
          <div className="columns small-12" onClick={this.showFilterModal}>
            Filters
          </div>
        </div>
      </div>
    );
  };

  public render() {
    const {
      query,
      selectedFund,
      startInvestmentFlow,
      resultPerPage,
      totalResults,
      loading,
      currentSelectedPage,
      results,
    } = this.state;
    const { url } = this.props;
    const { fundId, detailsSlug } = url.query;
    const startingCount =
      currentSelectedPage === 0 ? 0 : currentSelectedPage * resultPerPage;
    const finalCount =
      results.length < resultPerPage ? results.length : resultPerPage;
    const resultCountText = `Showing ${startingCount + 1} - ${
      startingCount + finalCount
    } out of ${totalResults} results`;
    return (
      <Fragment>
        <div className={cx('row mt30', searchStyles['pb0'])}>
          <div className="large-12 small-12 columns">
            <p className={cx(searchStyles['search-title'], 'mb20')}>
              Search from over 800+ top-performing Mutual Funds
            </p>
          </div>

          <div className={searchStyles['search-input-parent']}>
            <Field
              labelName=""
              name="search-fund"
              id="seach-fund"
              type="text"
              placeholder="Find a Mutual Fund by name, type or fundhouse"
              className={cx(
                'large-12 small-12 columns',
                searchStyles['search-input'],
                searchStyles['p0-desktop-only']
              )}
              value={query}
              onChange={this.handleSearchChange}
            />
          </div>
        </div>

        <div className="row mt20">
          <div className="large-3 columns desktop-only">
            <div>
              <span>Filters</span>
              <span
                className={cx(
                  searchStyles['show-more'],
                  searchStyles['clear-all-filters']
                )}
                onClick={this.clearAllFilters}
              >
                Clear all filters
              </span>
            </div>
            {this.getFilters()}
          </div>

          {!loading && totalResults ? (
            <div className="mb10 large-9 columns p0 desktop-only">
              <div className={cx('row', searchStyles['mr0'])}>
                <div className="large-6 columns">
                  <span>{resultCountText}</span>
                </div>
              </div>
            </div>
          ) : null}

          {loading ? <Loader /> : this.renderTable()}
        </div>

        {(fundId || detailsSlug) && selectedFund && startInvestmentFlow ? (
          <InvestFlowHandler
            {...this.props}
            onDismiss={this.dismissModal}
            selectedFund={selectedFund}
            sourceType="search-page"
            redirectUrl="/save/search"
          />
        ) : null}
        {this.getFilterContentMobile()}
      </Fragment>
    );
  }
}

export default withAppLayout(
  {
    title: 'Search from over 800+ top-performing Mutual Funds - ClearTax',
    description:
      'Use ClearTax Invest to search from over 800+ top-performing mutual funds and start your investment journey today!',
    hideHeaderSearch: true,
  },
  withCompareWidget(Search)
);



// WEBPACK FOOTER //
// ./pages/search.tsx